import hmacSHA512 from 'crypto-js/hmac-sha512';
import Base64 from 'crypto-js/enc-base64';
import { getBusinessId } from './utilities';
var CryptoJS = require("crypto-js");




export function AESEncrypt(pureText) {
    const dynamicValue = getBusinessId(); // Could use a date or something dynamic
    const privateKey = `${dynamicValue} secret key 123`;
    var ciphertext = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(pureText), privateKey).toString());
    return ciphertext;
}

export function AESDecrypt(encryptedText) {
    const dynamicValue = getBusinessId(); // Could use a date or something dynamic
    const privateKey = `${dynamicValue} secret key 123`;
    try {
        var bytes = CryptoJS.AES.decrypt(decodeURIComponent(encryptedText), privateKey);
        return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        return 0
    }
}

export function Sha256Hash(id, first, last) {
    const dynamicValue = getBusinessId(); // Could use a date or something dynamic
    const pureText = `${first}-${id}-${last}`;
    const privateKey = `${dynamicValue} secret key 123`;
    var hash = encodeURIComponent(Base64.stringify(hmacSHA512(pureText, privateKey)));
    return hash;
}